/* ══════════════════════════════════════════════════════════════════
   Überfällig im Brett — Prüfrunde Runde 10, N10-04 (05.10.2026).

   „7 sind draußen" stand rechts neben dem Brett, Balken hatten nur vier:
   Die drei Geräte aus V-2026-0001 waren nach ihrem Planende (02.10.) noch
   beim Kunden, und das Brett holte nur Belegungen, deren Plan das Fenster
   berührt. Die API holt sie jetzt mit (`routen/planung.ts`,
   `UEBERFAELLIG_B`); gezeichnet wird bis jetzt. Rein, damit es sich ohne
   Browser prüfen lässt.
   ══════════════════════════════════════════════════════════════════ */

import { kurzDatum } from "./kalender";

/**
 * **Überfällig statt der Uhrzeit von damals** (Prüfrunde Runde 11, N10-04
 * nachgeprüft): Auf dem schraffierten Balken stand „09:00–20:00" — das
 * Uhrfenster des Plans, der seit dem 02.10. vorbei ist. Ein überfälliger
 * Balken trägt an dieser Stelle „überfällig seit 02.10.", im Hinweis ebenso
 * (`masken/planung/Balken.tsx`). Ein i18n-Schlüssel, kein Satz.
 */
export function ueberfaelligSatz(
  bel: { ueberfaelligSeit?: string | undefined },
  t: (k: string, w?: Record<string, string | number>) => string,
): string {
  return bel.ueberfaelligSeit
    ? t("planung.ueberfaelligSeit", { datum: kurzDatum(new Date(`${bel.ueberfaelligSeit}T00:00:00`)) })
    : "";
}

/**
 * **Die kurze Form für einen schmalen Balken** (Prüfrunde Runde 12, N12-02):
 * „überfällig seit 02.10." passte in eine Tagesspalte der Woche (137 px)
 * nicht hinein — sichtbar war „überfäll", ohne Datum. Das Datum ist die
 * Aussage; „überfällig" sagen schon die rote Kapsel, die Schraffur und der
 * Hinweis, in dem der lange Satz steht. Welche Form steht, entscheidet die
 * Breite der Spalte (`stile/einsatzuhr.css`), nicht die Anwendung.
 */
export function ueberfaelligKurz(
  bel: { ueberfaelligSeit?: string | undefined },
  t: (k: string, w?: Record<string, string | number>) => string,
): string {
  return bel.ueberfaelligSeit
    ? t("planung.ueberfaelligKurz", { datum: kurzDatum(new Date(`${bel.ueberfaelligSeit}T00:00:00`)) })
    : "";
}

/**
 * **Bis wohin ein Balken gezeichnet wird** (Prüfrunde Runde 10, N10-04).
 * Eine überfällige Belegung — draußen, das Planende vorbei — reicht bis
 * jetzt; jede andere bis zu ihrem Planende. Das Planende selbst bleibt die
 * Auskunft (`bisZeit`, `bisUhr`): Es ist der Tag, seit dem das Gerät fehlt.
 */
export function gezeichnetesEnde(bis: string, ueberfaellig: boolean, jetzt: Date = new Date()): string {
  if (!ueberfaellig || !bis) return bis;
  const ende = new Date(bis);
  return Number.isNaN(ende.getTime()) || ende >= jetzt ? bis : jetzt.toISOString();
}


/**
 * **Der letzte Tag, an dem die Belegung das Gerät hält** — für Tageslisten,
 * die mit Kalendertagen statt Spalten rechnen (Telefon, `Agenda.tsx`). Ein
 * überfälliges Gerät hält es bis heute; das Planende (`bisTag`) bleibt die
 * Auskunft. `JJJJ-MM-TT` lässt sich als Text vergleichen.
 */
export function belegtBis(
  b: { bisTag?: string | undefined; ueberfaelligSeit?: string | undefined },
  heute: string,
): string | undefined {
  if (!b.bisTag) return undefined;
  return b.ueberfaelligSeit && heute > b.bisTag ? heute : b.bisTag;
}
